<template>
  <SecondaryNav>
    <template #top>
      <SecondaryTop text="Drops">
        <template #right>
          <router-link to="/store/drops/new">
            <NeueButton type="primary">New</NeueButton>
          </router-link>
        </template>
      </SecondaryTop>
    </template>
    <template #main>
      <div class="flex flex-col justify-between h-full">
        <div class="px-6 md:px-8 pt-6">
          <NeueWell class="mb-8">
            Drops define a certain ordering window. Within each drop, choose the Store and the Customer Smart lists who
            should be ordering from that Store, setup automatic order reminders which automatically include a unique
            link to each customer's cart, and optionally setup autofill and autocharge to run within the ordering
            window.
          </NeueWell>
          <DropTable link-base="/store/drops" />
        </div>
      </div>
    </template>
  </SecondaryNav>
</template>
<script>
import DropTable from '@/components/neue/DropTable.vue'

export default {
  components: {
    DropTable
  }
}
</script>
